import { ControlPopupContainer, ControlPopupContent } from './styles';
import { PopupMenu, PopupMenuItem } from './styles';
import { INITIAL_CONTROLS, useStore } from '../../../../store';
import { TrashSimple, X } from '@phosphor-icons/react';
import { useContext } from 'react';
import { TtsContext } from '../../../../contexts/TtsContext';
import { useTranslation } from 'react-i18next';

interface VolumePopupProps {
  blockId: string;
}

export const VolumePopup = ({ blockId }: VolumePopupProps) => {
  const { updateBlockControl, blocks } = useStore();
  const { hideToolbox } = useContext(TtsContext);

  const { t } = useTranslation('myapps');

  const index = blocks.findIndex((b) => b.id === blockId);

  const handleChange = (selectedOption: string) => {
    if (blocks[index] && blocks[index].controls.volume !== selectedOption) {
      updateBlockControl(blockId, 'volume', selectedOption);
      hideToolbox();
    }
  };

  const options = [
    { value: 'default', label: t('TTS_EFFECT_OPTION_DEFAULT') },
    { value: 'silent', label: t('TTS_EFFECT_OPTION_SILENT') },
    { value: 'x-soft', label: t('TTS_EFFECT_OPTION_X_SOFT') },
    { value: 'soft', label: t('TTS_EFFECT_OPTION_SOFT') },
    { value: 'medium', label: t('TTS_EFFECT_OPTION_MEDIUM') },
    { value: 'x-loud', label: t('TTS_EFFECT_OPTION_X_LOUD') },
  ];

  return (
    <ControlPopupContainer>
      <ControlPopupContent>
        <PopupMenu>
          {options.map((option) => (
            <PopupMenuItem
              isSelected={blocks[index]?.controls?.volume === option.value}
              key={crypto.randomUUID() + `volume-options-` + option.value}
              onClick={() => handleChange(option.value)}
            >
              {option.label}
            </PopupMenuItem>
          ))}
        </PopupMenu>
      </ControlPopupContent>
      {blocks[index]?.controls?.volume !== 'default' && (
        <PopupMenuItem
          isSelected={false}
          onClick={() => handleChange({ ...INITIAL_CONTROLS }.volume)}
          style={{ border: '1px solid #fd6262' }}
        >
          <X />
          Clear
        </PopupMenuItem>
      )}
    </ControlPopupContainer>
  );
};
